import React, { useState } from "react"; 
import TrophyIcon from '../Images/cup.svg'; 
import TruckIcon from '../Images/car.svg'; 
import TagIcon from '../Images/wallet.png';
import collectionBackgroundImage from '../Images/Untitled-1.png';



const SliderAllCategories = () => {

  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    (
<div className="px-6 flex flex-col md:flex-row justify-between items-center "
      style={{
        backgroundImage: `url(${collectionBackgroundImage})`,
        backgroundSize: 'contain',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            aspectRatio: '16 / 6',
      }}
       >

<div className="flex-1  mr-48 md:mr-0 mt-10">
                    <h1 className="text-white font-bold text-xl md:text-4xl xl:text-6xl leading-tight mb-4 px-0 xl:px-20  ">
        All Categories 
        </h1>
        <p className="text-white text-xs md:text-base mb-6 px-0 xl:px-20 w-40 md:w-full max-w-2xl">
          Find more about all our printing services
        </p>


      </div>

    </div>
    ),

];



  return (
    <>    
      <div className="w-full bg-white">
   <div className="max-w-screen-xl mx-auto relative">
 


      {slides[currentSlide]}


    



      <div className="flex items-center justify-end space-x-2">
  {slides.map((_, index) => (
    <span key={index}
          style={{
            width: currentSlide === index ? '20px' : '8px',
            backgroundColor: currentSlide === index ? '#ec008c' : 'white',
            opacity: currentSlide === index ? '2' : '0.5',
          }}
          
    ></span>
  ))}
</div>




    </div>
    </div>


    <div className=" flex flex-col  md:flex-row justify-between items-start md:items-center  px-20 md:px-16 xl:px-48 space-y-12 md:space-y-0  bg-white py-8 md:py-8 max-w-screen-2xl mx-auto px-4 xl:px-20 relative">
      <div className="flex flex-row items-center gap-4 pl-0 md:pl-1">
        <img src={TrophyIcon} alt="Premium Quality" className="h-8 w-8" />
        <p className="text-black text-xs xl:text-xl  mt-2">Premium Quality Made In The UK</p>
      </div>
      <div className="flex flex-row items-center gap-4">
        <img src={TruckIcon} alt="Fast Delivery" className="h-8 w-8" />
        <p className="text-black text-xs xl:text-xl mt-2">Fast Production And Delivery</p>
      </div>
      <div className="flex flex-row items-center gap-4 ">
        <img src={TagIcon} alt="Low Price" className="h-8 w-8" />
        <p className="text-black text-xs xl:text-xl mt-2">Low Price And Low Quantity Orders</p>
      </div>
    </div>


  

 </>

  );
};

export default SliderAllCategories;
